import { SENTRY_DSN } from './settings.ts';
import * as Sentry from '@sentry/react';

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    tracesSampleRate: 1.0,
  });

  console.log('Sentry initialized');
}
